import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Input } from 'reactstrap';
import classnames from 'classnames';
import _ from 'underscore';
import { kebabCase, get as getValueAtPath } from 'lodash';
import Icon from '../containers/icon';
import entityComposition from '../classes/entityComposition';
class NumberInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      errorMaxLength: false
    };
    props.schemaActions.refresh();
    this.handleChange = this.handleChange.bind(this);
    this.getPrecision = this.getPrecision.bind(this);
    this.getScale = this.getScale.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.parseValue = this.parseValue.bind(this);
    this.className = "t-ni-input tqc-control t-ni-".concat(kebabCase(props.entity), "-").concat(kebabCase(props.field));
  }

  /* eslint-disable react/sort-comp, camelcase */
  UNSAFE_componentWillReceiveProps(nextProps) {
    const value = this.state.value;
    /* eslint-enable react/sort-comp, camelcase */
    if (nextProps.value !== value) {
      this.setState({
        value: nextProps.value
      });
    }
  }

  // when user leaves input, we want to parse the value and remove any junk
  onBlur() {
    const value = this.state.value;
    if (value) {
      this.setState({
        value: this.parseValue(value.toString())
      });
    }
  }
  getScale() {
    const _this$props = this.props,
      schema = _this$props.schema,
      entity = _this$props.entity,
      field = _this$props.field;
    return getValueAtPath(schema, "".concat(entity, ".").concat(field, ".scale"), 4);
  }
  getPrecision() {
    const _this$props2 = this.props,
      schema = _this$props2.schema,
      entity = _this$props2.entity,
      field = _this$props2.field;
    const precision = getValueAtPath(schema, "".concat(entity, ".").concat(field, ".precision"), 12);
    return precision - this.getScale();
  }
  parseValue(value) {
    const props = this.props;
    let newValue = null;
    /* eslint-disable-next-line prefer-regex-literals */
    const regEx = new RegExp(/^-?\d*\.?\d*$/);
    let errorMaxLength = false;
    if (value.length < 1) {
      this.setState({
        errorMaxLength: false
      });
    } else if (value) {
      // rule out non-number inputs
      const number = Number(value);
      if (Number.isNaN(number)) {
        newValue = props.value;
      } else {
        newValue = number;
        // limit input after the decimal to component's precision
        const decimals = value.split('.');

        // if no decimal (`3`) OR a decimal with following numbers (`3.14`)
        // this rules out a value with a decimal but no proceeding numbers (`3.`)
        if (decimals.length === 1 || decimals.length > 1 && decimals[1].length > 0) {
          if (decimals.length > 1) {
            // handle precision limits if we've got decimal values
            newValue = decimals[1].length <= this.getPrecision() ? newValue : props.value;
          }
        }
        if (regEx.test(value)) {
          // If it's only . or numbers, do this:
          // Check to see if the value has too many integer or decimal
          // places - and fix it
          if (_.contains(value, '.')) {
            const numbers = value.split('.');
            if (numbers[0].length > this.getPrecision() || numbers[1].length > this.getScale()) {
              numbers[0] = numbers[0].substring(0, this.getPrecision());
              numbers[1] = numbers[1].substring(0, this.getScale());
              newValue = '';
              newValue = newValue.concat(numbers[0], '.', numbers[1]);
              errorMaxLength = true;
            }
          } else if (value.length > this.getPrecision()) {
            newValue = value.substring(0, this.getPrecision());
            errorMaxLength = true;
          }
          this.setState({
            errorMaxLength
          });
        }

        // make sure to turn this into a number instead of a string
        if (this.getPrecision() === 0) {
          newValue = parseInt(newValue, 10);
        } else {
          newValue = parseFloat(newValue);
        }
      }
    }
    return newValue;
  }
  handleChange(event) {
    const onChange = this.props.onChange;
    event.stopPropagation();
    const value = event.target.value;
    if (value) {
      const parsedValue = this.parseValue(value);
      onChange(parsedValue);
    } else {
      onChange(null);
    }

    // regardless of what else happens, let the user type in what they want.
    this.setState({
      value
    });
  }
  render() {
    const _this$props3 = this.props,
      label = _this$props3.label,
      type = _this$props3.type,
      placeholder = _this$props3.placeholder,
      disabled = _this$props3.disabled;
    const _this$state = this.state,
      errorMaxLength = _this$state.errorMaxLength,
      value = _this$state.value;
    const styles = {
      spanErrorMaxLength: {
        width: '150px'
      },
      inputErrorMaxLength: {
        paddingRight: '85px'
      },
      inputError: {
        paddingRight: '85px'
      },
      msg: {
        top: label ? '35px' : '7px',
        right: '30px',
        position: 'absolute'
      }
    };
    const hasErrors = errorMaxLength;
    const classes = classnames({
      'form-group': true,
      'has-error': hasErrors,
      'has-feedback': hasErrors
    });

    // Determine the feedback text
    let spanStyle;
    let msg;
    let inputStyle;
    if (errorMaxLength) {
      inputStyle = styles.inputError;
      spanStyle = styles.spanErrorMaxLength;
      msg = 'too long';
    }
    const feedback = /*#__PURE__*/React.createElement("span", {
      className: "form-control-feedback t-ni-feedback",
      "aria-hidden": "true",
      style: spanStyle
    }, /*#__PURE__*/React.createElement("span", {
      style: styles.msg
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "times"
    }), " ", msg));

    // initializing to empty string if nothing set for now.
    return /*#__PURE__*/React.createElement("div", {
      className: classes
    }, /*#__PURE__*/React.createElement(FormGroup, null, label ? /*#__PURE__*/React.createElement(Label, null, label) : undefined, /*#__PURE__*/React.createElement(Input, {
      invalid: hasErrors,
      className: this.className,
      style: inputStyle,
      type: type || 'text',
      value: value === 0 ? 0 : value || '',
      placeholder: placeholder,
      onChange: this.handleChange,
      onBlur: this.onBlur,
      disabled: disabled
    })), hasErrors ? feedback : '');
  }
}
NumberInput.defaultProps = {
  label: null,
  placeholder: 'Numeric only',
  type: null,
  value: null,
  disabled: false
};
NumberInput.propTypes = {
  schemaActions: PropTypes.shape({
    refresh: PropTypes.func
  }).isRequired,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  label: PropTypes.string,
  entity: PropTypes.string.isRequired,
  field: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  schema: PropTypes.shape({
    loading: PropTypes.string
    // plus all the entities
  }).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export { NumberInput as TestNumberInput };
export default entityComposition(NumberInput, ['schema'], {}, []);